// Greek / English translations
export const translations = {
  el: {
    // Common
    "app.name": "Ελληνικό Δίκτυο Εξαγωγών",
    "app.tagline": "Πλατφόρμα CRM για επιχειρήσεις εξαγωγών",
    "common.save": "Αποθήκευση",
    "common.cancel": "Ακύρωση",
    "common.delete": "Διαγραφή",
    "common.edit": "Επεξεργασία",
    "common.create": "Δημιουργία",
    "common.add": "Προσθήκη",
    "common.search": "Αναζήτηση",
    "common.loading": "Φόρτωση...",
    "common.no_data": "Δεν υπάρχουν δεδομένα",
    "common.email": "Email",
    "common.password": "Κωδικός",
    "common.name": "Όνομα",
    "common.phone": "Τηλέφωνο",
    "common.country": "Χώρα",
    "common.notes": "Σημειώσεις",
    "common.actions": "Ενέργειες",
    "common.status": "Κατάσταση",
    "common.value": "Αξία",
    "common.close": "Κλείσιμο",
    "common.confirm": "Επιβεβαίωση",
    "common.back": "Πίσω",
    "common.welcome": "Καλώς ήρθατε",

    // Auth
    "auth.login": "Σύνδεση",
    "auth.logout": "Αποσύνδεση",
    "auth.register": "Εγγραφή",
    "auth.register_company": "Εγγραφή εταιρείας",
    "auth.signin_to_account": "Συνδεθείτε στον λογαριασμό σας",
    "auth.create_account": "Δημιουργήστε λογαριασμό",
    "auth.no_account": "Δεν έχετε λογαριασμό;",
    "auth.have_account": "Έχετε ήδη λογαριασμό;",
    "auth.company_name": "Όνομα εταιρείας",
    "auth.owner_name": "Όνομα ιδιοκτήτη",
    "auth.industry": "Κλάδος",

    // Nav
    "nav.dashboard": "Πίνακας ελέγχου",
    "nav.pipeline": "Διοχέτευση",
    "nav.contacts": "Επαφές",
    "nav.customers": "Επαφές & Εταιρείες",
    "nav.companies": "Εταιρείες",
    "nav.opportunities": "Ευκαιρίες",
    "nav.products": "Προϊόντα",
    "nav.calls": "Κλήσεις",
    "nav.sales_reps": "Πωλητές",
    "nav.reports": "Αναφορές",
    "nav.inquiries": "Αιτήματα",
    "nav.company_profile": "Δημόσιο προφίλ",
    "nav.settings": "Ρυθμίσεις",
    "nav.platform": "Πλατφόρμα",
    "nav.owner_reports": "Αναφορές",
    "nav.owner_calls_emails": "Κλήσεις πωλητών",
    "nav.owner_chat": "Επικοινωνία με πωλητή",
    "nav.chat_owner": "Επικοινωνία με ιδιοκτήτη",
    "nav.work_report": "Αναφορά εργασίας",

    // Dashboard
    "dashboard.title": "Πίνακας ελέγχου",
    "dashboard.welcome": "Καλώς ήρθατε ξανά",
    "dashboard.total_contacts": "Συνολικές επαφές",
    "dashboard.total_opportunities": "Συνολικές ευκαιρίες",
    "dashboard.total_calls": "Συνολικές κλήσεις",
    "dashboard.deals_won": "Κερδισμένες συμφωνίες",
    "dashboard.conversion_rate": "Ποσοστό μετατροπής",
    "dashboard.pipeline_value": "Αξία διοχέτευσης",
    "dashboard.won_value": "Αξία κερδών",
    "dashboard.new_inquiries": "Νέα αιτήματα",
    "dashboard.country_performance": "Απόδοση ανά χώρα",
    "dashboard.funnel": "Ανάλυση διοχέτευσης",
    "dashboard.rep_kpis": "KPIs Πωλητών",

    // Pipeline stages
    "stage.new_lead": "Νέος Lead",
    "stage.contacted": "Επικοινωνία",
    "stage.interested": "Ενδιαφερόμενος",
    "stage.meeting_scheduled": "Ραντεβού",
    "stage.proposal_sent": "Πρόταση",
    "stage.negotiation": "Διαπραγμάτευση",
    "stage.won": "Κερδισμένη",
    "stage.lost": "Χαμένη",
    "stage.new": "Νέα",
    "stage.called": "Κλήση",
    "stage.callback_scheduled": "Επανάκληση",
    "stage.not_interested": "Δεν ενδιαφέρεται",

    // Calls
    "call.outcome": "Αποτέλεσμα",
    "call.duration": "Διάρκεια (λεπτά)",
    "call.date": "Ημερομηνία",
    "outcome.no_answer": "Δεν απάντησε",
    "outcome.callback_requested": "Ζήτησε κλήση",
    "outcome.interested": "Ενδιαφερόμενος",
    "outcome.not_interested": "Δεν ενδιαφέρεται",
    "outcome.meeting_scheduled": "Συνάντηση",
    "outcome.proposal_requested": "Πρόταση",
    "outcome.deal_won": "Κερδισμένη",
    "outcome.deal_lost": "Χαμένη",

    // Public
    "public.cta_inquiry": "Στείλτε αίτημα",
    "public.cta_quote": "Ζητήστε προσφορά",
    "public.cta_meeting": "Προγραμματίστε συνάντηση",
    "public.products": "Προϊόντα",
    "public.about": "Σχετικά με την εταιρεία",
    "public.contact": "Επικοινωνία",
    "public.certifications": "Πιστοποιήσεις",
    "public.countries_served": "Χώρες εξαγωγής",
    "public.sales_team": "Ομάδα πωλήσεων",
    "public.message": "Μήνυμα",
    "public.send": "Αποστολή",
    "public.thanks": "Ευχαριστούμε! Το μήνυμά σας στάλθηκε.",

    // Misc
    "search.placeholder": "Αναζήτηση...",
    "lang.switch": "Γλώσσα",
  },
  en: {
    "app.name": "Greek Export Network",
    "app.tagline": "CRM platform for export businesses",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.create": "Create",
    "common.add": "Add",
    "common.search": "Search",
    "common.loading": "Loading...",
    "common.no_data": "No data yet",
    "common.email": "Email",
    "common.password": "Password",
    "common.name": "Name",
    "common.phone": "Phone",
    "common.country": "Country",
    "common.notes": "Notes",
    "common.actions": "Actions",
    "common.status": "Status",
    "common.value": "Value",
    "common.close": "Close",
    "common.confirm": "Confirm",
    "common.back": "Back",
    "common.welcome": "Welcome",

    "auth.login": "Sign in",
    "auth.logout": "Sign out",
    "auth.register": "Register",
    "auth.register_company": "Register company",
    "auth.signin_to_account": "Sign in to your account",
    "auth.create_account": "Create an account",
    "auth.no_account": "Don't have an account?",
    "auth.have_account": "Already have an account?",
    "auth.company_name": "Company name",
    "auth.owner_name": "Owner name",
    "auth.industry": "Industry",

    "nav.dashboard": "Dashboard",
    "nav.pipeline": "Pipeline",
    "nav.contacts": "Contacts",
    "nav.customers": "Customers",
    "nav.companies": "Companies",
    "nav.opportunities": "Opportunities",
    "nav.products": "Products",
    "nav.calls": "Calls",
    "nav.sales_reps": "Sales Reps",
    "nav.reports": "Reports",
    "nav.inquiries": "Inquiries",
    "nav.company_profile": "Public Profile",
    "nav.settings": "Settings",
    "nav.platform": "Platform",
    "nav.owner_reports": "Reports",
    "nav.owner_calls_emails": "Rep Calls",
    "nav.owner_chat": "Chat with rep",
    "nav.chat_owner": "Chat with owner",
    "nav.work_report": "Work report",

    "dashboard.title": "Dashboard",
    "dashboard.welcome": "Welcome back",
    "dashboard.total_contacts": "Total contacts",
    "dashboard.total_opportunities": "Total opportunities",
    "dashboard.total_calls": "Total calls",
    "dashboard.deals_won": "Deals won",
    "dashboard.conversion_rate": "Conversion rate",
    "dashboard.pipeline_value": "Pipeline value",
    "dashboard.won_value": "Won value",
    "dashboard.new_inquiries": "New inquiries",
    "dashboard.country_performance": "Country performance",
    "dashboard.funnel": "Funnel analytics",
    "dashboard.rep_kpis": "Sales rep KPIs",

    "stage.new_lead": "New Lead",
    "stage.contacted": "Contacted",
    "stage.interested": "Interested",
    "stage.meeting_scheduled": "Meeting",
    "stage.proposal_sent": "Proposal",
    "stage.negotiation": "Negotiation",
    "stage.won": "Won",
    "stage.lost": "Lost",
    "stage.new": "New",
    "stage.called": "Called",
    "stage.callback_scheduled": "Callback",
    "stage.not_interested": "Not interested",

    "call.outcome": "Outcome",
    "call.duration": "Duration (min)",
    "call.date": "Date",
    "outcome.no_answer": "No answer",
    "outcome.callback_requested": "Callback requested",
    "outcome.interested": "Interested",
    "outcome.not_interested": "Not interested",
    "outcome.meeting_scheduled": "Meeting scheduled",
    "outcome.proposal_requested": "Proposal requested",
    "outcome.deal_won": "Deal won",
    "outcome.deal_lost": "Deal lost",

    "public.cta_inquiry": "Send Inquiry",
    "public.cta_quote": "Request Quotation",
    "public.cta_meeting": "Request Meeting",
    "public.products": "Products",
    "public.about": "About the company",
    "public.contact": "Contact",
    "public.certifications": "Certifications",
    "public.countries_served": "Countries served",
    "public.sales_team": "Sales team",
    "public.message": "Message",
    "public.send": "Send",
    "public.thanks": "Thanks! Your message has been sent.",

    "search.placeholder": "Search...",
    "lang.switch": "Language",
  },
};

export const STAGES = [
  "new",
  "called",
  "callback_scheduled",
  "meeting_scheduled",
  "proposal_sent",
  "not_interested",
  "won",
  "lost",
];

export const STAGE_COLORS = {
  new: "#64748B",
  called: "#3B82F6",
  callback_scheduled: "#F59E0B",
  meeting_scheduled: "#06B6D4",
  proposal_sent: "#8B5CF6",
  not_interested: "#EF4444",
  won: "#16A34A",
  lost: "#94A3B8",
};

export const CALL_OUTCOMES = [
  "no_answer",
  "callback_requested",
  "interested",
  "not_interested",
  "meeting_scheduled",
  "proposal_requested",
  "deal_won",
  "deal_lost",
];
